import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "selectAll", "deleteButton"]
  
  connect() {
    // Set initial state - hide button by default
    this.deleteButtonTarget.classList.add('d-none')
    this.updateDeleteButtonState()
  }
  
  toggleSelectAll() {
    const isChecked = this.selectAllTarget.checked
    this.selectTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateDeleteButtonState()
  }
  
  toggleSelect() {
    // If any checkbox is unchecked, uncheck "select all"
    if (this.selectTargets.some(checkbox => !checkbox.checked)) {
      this.selectAllTarget.checked = false
    } 
    // If all checkboxes are checked, check "select all"
    else if (this.selectTargets.every(checkbox => checkbox.checked)) {
      this.selectAllTarget.checked = true
    }
    
    this.updateDeleteButtonState()
  }
  
  updateDeleteButtonState() {
    const hasSelection = this.selectTargets.some(checkbox => checkbox.checked)
    
    // Show/hide the delete button instead of just disabling it
    if (hasSelection) {
      this.deleteButtonTarget.classList.remove('d-none')
      this.deleteButtonTarget.disabled = false
    } else {
      this.deleteButtonTarget.classList.add('d-none')
      this.deleteButtonTarget.disabled = true
    }
    
    // Update the count of selected items
    const selectedCount = this.selectTargets.filter(checkbox => checkbox.checked).length
    this.deleteButtonTarget.textContent = selectedCount > 0 
      ? `${this.deleteButtonTarget.dataset.baseText} (${selectedCount})` 
      : this.deleteButtonTarget.dataset.baseText
  }
  
  delete(event) {
    event.preventDefault()
    
    if (!confirm(this.deleteButtonTarget.dataset.confirmMessage)) {
      return
    }
    
    const selectedIds = this.selectTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
    
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    
    fetch(this.deleteButtonTarget.dataset.url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({ document_ids: selectedIds })
    })
    .then(response => {
      if (response.ok) {
        // Reset all checkboxes
        this.selectTargets.forEach(checkbox => {
          checkbox.checked = false
        })
        this.selectAllTarget.checked = false
        
        // Hide the delete button
        this.deleteButtonTarget.classList.add('d-none')
        this.deleteButtonTarget.disabled = true
      }
    })
    .catch(error => console.error('Error:', error))
  }
}